module.exports = __webpack_public_path__ + "static/media/Logo - Transparente.75a79802.png";